import type { AgentSelectOption } from '$form-fields';
import { formatTeamMemberId } from './formatTeamMemberId';

type AgentIds = Pick<AgentSelectOption, 'id' | 'teamId'>;

export function areAgentsEquivalent(agentA: AgentIds, agentB?: AgentIds) {
  const agentATeamMemberId = formatTeamMemberId(agentA.id, agentA.teamId);
  const agentBTeamMemberId = formatTeamMemberId(
    agentB?.id ?? '',
    agentB?.teamId ?? '',
  );

  return agentATeamMemberId === agentBTeamMemberId;
}

type AgentProfileWithRequiredFields<T> = T & {
  teamId: string;
  companyName: string;
  brokerageId: string;
};

export function doesAgentHaveRequiredFields<
  T extends {
    brokerageId?: string | null;
    companyName?: string | null;
    teamId?: string | null;
  },
>(agent: T): agent is AgentProfileWithRequiredFields<T> {
  return (
    Boolean(agent.brokerageId) &&
    Boolean(agent.teamId) &&
    Boolean(agent.companyName)
  );
}
